import { useEffect, useRef, useState } from 'react';
import MapCustomControl from './MapCustomControl';
import { MapCustomControlProps } from './MapCustomControlProps';

export const useMapboxControl = ({mapRef, position} : MapCustomControlProps): HTMLElement | null => {

  const controlRef = useRef<MapCustomControl>(new MapCustomControl()).current;
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {

    if (!mapRef?.current) return;

    mapRef.current.addControl(controlRef, position);
    setContainer(controlRef.container);

    return () => {
      if (!!mapRef?.current && !!controlRef) {
        mapRef.current.removeControl(controlRef);
      }
    };

  }, [mapRef, position]);

  return container;
  
};